<template>
  <div class="w-full">
    <div class="card-shadow text-black display-date mt-1">
      <p class="text-center">{{ displayDate }}</p>
    </div>
    <div class="card-shadow bg-black">
      <p class="px-4 text-center display-time">{{ displayTime }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { DATE_TIME } from '@/utils/constants'
import { format } from 'date-fns'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  name: 'DateTimeDisplay',
})
export default class DateTimeDisplay extends Vue {
  @Prop({ required: true }) currentTime!: Date

  get displayDate() {
    return format(new Date(), DATE_TIME.DISPLAY_FORMAT)
  }

  get displayTime() {
    return format(this.currentTime, DATE_TIME.TIME_WITH_SECOND_FORMAT)
  }
}
</script>

<style lang="scss" scoped>
.card-shadow {
  padding: 5px;
  margin: 0px 10px;
  border: 1px solid #efefef;
  font-size: 20px !important;
}

.display-date {
  background: #ffff00;
}

.display-time {
  color: #ffff00;
}
</style>
